import styled from 'styled-components';

const LogoStyle = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  @media (max-width: 335px) {
    svg {
      height: 20px;
    }
  }
`;

export default LogoStyle;
